'use strict';
const angular = require('angular');

module.exports = angular
  .module('app.domain-directives', [])
  .directive('domainList', require('./DomainListDirective.js'))
  .directive('domainError', require('./DomainErrorMessageDirective.js'))
  .directive('domainEditorProperty', require('./DomainEditorPropertyDirective.js'))
  .directive('modalSelector', require('./ModalSelectorDirective.js'));



// WEBPACK FOOTER //
// ./src/js/domain-directives/index.js